<template>
    <section>
        <Header></Header>
        <div class="body">

            <SectionWelcome class="pc"/>
            <SectionWelcomeMobile class="mobile"/>
            <SectionWelcomeBottom/>
            <SectionProjectStep/>
            <SectionPriceGraph/>
            <SectionTech/>
            <SectionPartner/>
            <SectionPartnerReference/>
            <SectionReference label="포트폴리오"/>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from '../components/Header.vue'
    import Footer from '../components/Footer.vue'
    import SectionWelcome from '../components/SectionWelcome.vue'
    import SectionWelcomeMobile from '../components/SectionWelcomeMobile.vue'
    import SectionWelcomeBottom from '../components/SectionWelcomeBottom.vue'
    import SectionProjectStep from '../components/SectionProjectStep.vue'
    import SectionPriceGraph from '../components/SectionPriceGraph.vue'
    import SectionTech from '../components/SectionTech.vue'
    import SectionPartner from '../components/SectionPartner.vue'
    import SectionPartnerReference from '../components/SectionPartnerReference.vue'
    import SectionReference from '../components/SectionReference.vue'
    
    import loginService from '../services/loginService'

    export default {
        name: "Main",
        components: {
            Header,
            Footer,
            SectionWelcome,
            SectionWelcomeMobile,
            SectionWelcomeBottom,
            SectionProjectStep,
            SectionPriceGraph,
            SectionTech,
            SectionPartner,
            SectionPartnerReference,
            SectionReference,
        },
        data: function () {
            return {
                success: false,
                loginErrorMsg: "",
                username: "",
                password: "",
            }
        },
        mounted() {
            
        },
        methods: {
            async login() {
                if(!this.username || !this.password)
                    return;

                const result = await loginService.login(this.username, this.password);
                if (result.r) {
                    this.success = true;
                    this.loginErrorMsg = '';
                } else {
                    this.success = false;
                    this.loginErrorMsg = result.msg;
                }
                console.log(result)

            }
        }
    }
</script>

<style scoped>

</style>
